import React from "react";
import Skeleton from "react-loading-skeleton";
import type { TransformedProduct } from "../../../types/productApiTypes";

interface ProductInformationProps {
  productName: string;
  shortDescription: string | null;
  variationsLoading: boolean;
  isVariable: boolean;
  isCombinationAvailable: boolean;
}

const ProductInformation: React.FC<ProductInformationProps> = ({
  productName,
  shortDescription,
  variationsLoading,
}) => {
  const isLoading = variationsLoading;

  return (
    <>
      <h1 className="product-title">{productName}</h1>

      {/* Price and Stock Status sections are completely removed */}

      {shortDescription && (
        <div
          className="product-short-description"
          dangerouslySetInnerHTML={{ __html: shortDescription }}
        />
      )}
    </>
  );
};

export default ProductInformation;
